
window.myjQuery(document).ready(function($) {

    // Upload custom logo
    $('body').on('change', '.upload-custom-logo-file', function() {
      $(this).closest('form').find('.btn-upload-custom-logo').click();
    });

    // Preview stock insert

    $('body').on('change', 'select[name=stock_id]', function() {
      // $(this).closest('form').find('.btn-upload-custom-logo').click();
      // alert($(this).val());
      $('.btn-preview-stock-insert').click();
    });

    // search about cluttering up the global scope on jquery

    // Preview selected custom logo/artwork.
    /* $('body').on('change', '.custom-artwork-file', function() {
      let pane = $(this).next('.image-preview-pane');
      let img = pane.closest('img');
      let ext = $(this).val().split(".").pop().toLowerCase();
      if ($.inArray(ext, ['png', 'jpg', 'jpeg', 'pdf', 'ai', 'eps']) !== -1) {
        alert('images: '+ ext);
        img.attr('src', ''); // = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/833px-PDF_file_icon.svg.png'; // window.URL.createObjectURL(this.files[0]);
        // img.style.height = '80px';
        // img.style.width = '80px';
      } else if (ext == 'pdf') {
        alert('pdf: '+ ext);
      } else {
        alert('others: '+ ext);;
      }

      // let imgPane = $(this).closest('.custom-artwork-preview');
      // document.getElementById('previewPicture2').src = window.URL.createObjectURL(this.files[0]);
      // document.getElementById('previewPicture2').style.height = '80px';
      // document.getElementById('previewPicture').style.width = '80px'
    }); */

    // Prevent double-binding.
    var inputLine = 'input.input-line';
    $(document.body).off('change', inputLine);

    // Show remaining characters for an input line.
    // Add .badge-danger when reaching 75% of the max length.
    // Supports typing, backspace, pasting and delete.
    $('body').on('keyup change', inputLine,  function() {

      let pieceAdditionalCharacterCost = $('input[name=piece_additional_character_cost]').val();
      let allAdditionalCost = $('input[name=overall_additional_character_cost]').val();

      let inputMaxLength = $(this).attr('maxlength');
      let inputCharsCount = this.value.length;

      let remainingBlock = $(this).next('div').find('span.input-remaining-lines');

      remainingBlock.html(inputMaxLength - inputCharsCount);

      let pct = (parseInt(inputCharsCount) / parseInt(inputMaxLength) * 100).toFixed(2);

      if (pct > 75) {
        remainingBlock.addClass('bg-danger text-white').removeClass('bg-secondary bg-warning text-dark');
      } else if (pct > 60) {
        remainingBlock.addClass('bg-warning text-white').removeClass('bg-secondary bg-danger text-dark');
      } else {
        remainingBlock.addClass('bg-secondary text-dark').removeClass('bg-danger bg-warning text-white');
      }

      let linesForm = remainingBlock.closest('form');
      let totalFreeCharactersCount = linesForm.find('input[name=total_free_characters]').val();
      let freeCharactersRemainingCount = totalFreeCharactersCount;
      let extraCharacterCost = linesForm.find('input[name=additional_character_cost]').val();
      let totalFormCharactersCount = 0;
      let extraCharactersCount = 0;
      let totalExtraCharactersCost = 0;

      linesForm.find('.input-line').each(function () {
        totalFormCharactersCount += $(this).val().length;
      });

      freeCharactersRemainingCount -= totalFormCharactersCount;
      extraCharactersCount = totalFormCharactersCount - totalFreeCharactersCount;

      if (freeCharactersRemainingCount >= 0) {
        linesForm.find('.free-letters-left-count').text(freeCharactersRemainingCount);
        linesForm.find('.free-letters-left').show();
        linesForm.find('.additional-letters').hide();
      } else {
        linesForm.find('.additional-letters-count').text(extraCharactersCount);
        linesForm.find('.additional-letters').show();
        linesForm.find('.free-letters-left').hide();
      }

      if (extraCharactersCount > 0) {
        totalExtraCharactersCost = (extraCharacterCost * extraCharactersCount);
        linesForm.find('.additional-engraving-cost').text(totalExtraCharactersCost.toFixed(2).toString());
      } else {
        linesForm.find('.additional-engraving-cost').text('0.00');
      }

      if (totalExtraCharactersCost > pieceAdditionalCharacterCost) {

        totalCost = parseFloat(allAdditionalCost) + (parseFloat(totalExtraCharactersCost) - parseFloat(pieceAdditionalCharacterCost));
        // console.log('totalCost: '+ totalCost.toFixed(2));
        // $('.overall-additional-engraving-cost').html(totalCost.toFixed(2).toString());
      }
    });
  });

// Engraving Room - Warn the user about pending action when trying to leave the page.
(function() {
    // console.log('Unified engraving warning system loaded');
    
    // Global state tracking
    window.engravingState = {
        engraveButtonClicked: false,
        formModified: false,
        onReviewScreen: false
    };
    
    // Track form input changes
    document.addEventListener('input', function(e) {
        if (e.target.matches('.piece-body input[type="text"]')) {
            // console.log('Form input changed');
            window.engravingState.formModified = true;
        }
    });
    
    // Intercept all turbo button clicks
    document.addEventListener('click', function(e) {
        // console.log('Click detected');
        
        const turboButton = e.target.closest('.btn-turbo');
        if (!turboButton) return;
        
        // console.log('Turbo button clicked');
        
        // Screen 1: .engrave-trigger clicked
        if (e.target.closest('.engrave-trigger')) {
            // console.log('Engrave trigger clicked');
            window.engravingState.engraveButtonClicked = true;
            return; // Allow navigation
        }
        
        // Screen 2: Save & Review clicked or Autosave clicked
        if (e.target.closest('.btn-save-review')) {
            // console.log('Save & Review clicked');
            window.engravingState.formModified = false;
            window.engravingState.onReviewScreen = true;
            return; // Allow navigation
        }
        // Screen 2: Autosave clicked
        if (e.target.closest('.btn-auto-save')) {
            return; // Allow navigation
        }        

        // Screen 3: Set Engraving clicked
        if (e.target.closest('.btn-set-engraving')) {
            // console.log('Set Engraving clicked');
            window.engravingState.onReviewScreen = false;
            return; // Allow navigation
        }
        
        // Screen 3: Change Engraving or Go Back clicked
        if (e.target.closest('.btn-change-engraving') || e.target.closest('.btn-go-back')) {
            // console.log('Change/Go Back clicked');
            window.engravingState.onReviewScreen = false;
            return; // Allow navigation
        }
        
        // Check which screen we're on and show appropriate warning
        const hasEngraveButtons = document.querySelectorAll('.engrave-trigger').length > 0;
        const hasFormInputs = document.querySelector('.piece-body input[type="text"]') !== null;
        const hasSetEngravingBtn = document.querySelector('.btn-set-engraving') !== null;
        
        /* console.log('Screen check:', {
            hasEngraveButtons,
            hasFormInputs,
            hasSetEngravingBtn,
            state: window.engravingState
        }); */
        
        let warningMessage = null;
        
        // Screen 1: Haven't clicked engrave button yet
        if (hasEngraveButtons && !window.engravingState.engraveButtonClicked) {
            warningMessage = 'You have not started the engraving session. Leave page anyway?';
        }
        // Screen 2: Form has unsaved changes
        else if (hasFormInputs && window.engravingState.formModified) {
            warningMessage = 'You have unsaved changes on engraving. Leave page anyway?';
        }
        // Screen 3: On review screen but haven't set engraving
        else if (hasSetEngravingBtn && window.engravingState.onReviewScreen) {
            warningMessage = 'You have not set the engraving yet. Leave page anyway?';
        }
        
        if (warningMessage) {
            // console.log('Showing warning:', warningMessage);
            const confirmLeave = confirm(warningMessage);
            console.log('Engraving session warning: '+ warningMessage);
            
            if (!confirmLeave) {
                console.log('Engraving session: Customer stayed.');
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            } else {
                console.log('Engraving session: Customer left.');
                // Reset appropriate flags
                if (hasEngraveButtons) window.engravingState.engraveButtonClicked = false;
                if (hasFormInputs) window.engravingState.formModified = false;
                if (hasSetEngravingBtn) window.engravingState.onReviewScreen = false;
            }
        }
    }, true);
    
    // Handle beforeunload for closing tab/window
    window.addEventListener('beforeunload', (e) => {
        const hasEngraveButtons = document.querySelectorAll('.engrave-trigger').length > 0;
        const hasFormInputs = document.querySelector('.piece-body input[type="text"]') !== null;
        const hasSetEngravingBtn = document.querySelector('.btn-set-engraving') !== null;
        
        let shouldWarn = false;
        
        if (hasEngraveButtons && !window.engravingState.engraveButtonClicked) {
            shouldWarn = true;
        } else if (hasFormInputs && window.engravingState.formModified) {
            shouldWarn = true;
        } else if (hasSetEngravingBtn && window.engravingState.onReviewScreen) {
            shouldWarn = true;
        }
        
        if (shouldWarn) {
            e.preventDefault();
            e.returnValue = '';
            return '';
        }
    });
})();